<template>
  <tbody>
    <tr
      v-for="(fee_item, i) in state_fee_items"
      :key="i"
      class="border-2"
      :class="[
        fee_item.available_after_registration
          ? 'bg-gray-200 text-gray-500'
          : '',
      ]"
    >
      <td class="border-b px-4 py-2">
        <p>
          {{ fee_item.custom_name ? fee_item.custom_name : fee_item.fee.name }}
        </p>
        <p
          v-if="fee_item.available_after_registration"
          class="text-xs"
        >
          Available after registration
        </p>
      </td>
      <td class="border-b px-4 py-2">$ {{ fee_item.amount }}</td>
    </tr>
    <tr>
      <td
        class="border-b px-4 py-2 text-center"
        colspan="2"
      >
        <label class="font-bold">
          Total Payment
        </label>
      </td>
    </tr>
    <!-- Total payment  -->
    <tr
      v-if="payFull && !payCustom"
      class="border-2 font-semibold"
      :class="{ 'text-green-900 bg-green-100': !discountCode.isValid }"
    >
      <td
        v-if="forAll || onlyIL"
        class="px-4 py-2"
        :class="{
          'border-t-2 border-b-2 border-l-2 border-green-400': !discountCode.isValid,
        }"
      >
        Tuition & Exam Fee
      </td>
      <td
        v-if="onlyTN"
        class="px-4 py-2"
        :class="{
          'border-t-2 border-b-2 border-l-2 border-green-400': !discountCode.isValid,
        }"
      >
        Tuition <span v-if="withExamFee">& Exam Fee</span>
      </td>
      <td
        v-if="forAll || onlyIL"
        class="px-4 py-2"
        :class="{
          'border-t-2 border-b-2 border-r-2 border-green-400': !discountCode.isValid,
        }"
      >
        $ {{ totalPrice }}
      </td>
      <td
        v-if="onlyTN"
        class="px-4 py-2"
        :class="{
          'border-t-2 border-b-2 border-r-2 border-green-400': !discountCode.isValid,
        }"
      >
        $ {{ totalPrice }}
      </td>
    </tr>
    <!-- Coupon breakdown -->
    <slot
      name="total-coupon-breakdown"
      v-bind:discountCode="discountCode"
    ></slot>
    <!-- End Coupon breakdown-->

    <tr
      v-if="!payFull && !payCustom && availableForPayment"
      :class="[
        !payFull
          ? 'text-green-900 bg-green-100 font-semibold'
          : 'text-green-900 bg-green-100 font-semibold',
      ]"
    >
      <td class="border-t-2 border-b-2 border-l-2 border-green-400 px-4 py-2">
        Registration Only
      </td>
      <td class="border-t-2 border-b-2 border-r-2 border-green-400 px-4 py-2">
        $ {{ depositAmount }}
      </td>
    </tr>
    <tr
      v-if="payCustom"
      :class="[
        !payFull
          ? 'text-green-900 bg-green-100 font-semibold'
          : 'text-green-900 bg-green-100 font-semibold',
      ]"
    >
      <td class="border-t-2 border-b-2 border-l-2 border-green-400 px-4 py-2">
        Your Payment
      </td>
      <td class="border-t-2 border-b-2 border-r-2 border-green-400 px-4 py-2">
        $ {{ payCustomAmount }}
      </td>
    </tr>
    <!-- Applicacion fee -->
    <tr
      v-if="state == 'MA' && maApplicationFee > 0"
      class="border-2 font-semibold text-green-900 bg-green-100 font-semibold"
    >
      <td class="px-4 py-2 border-t-2 border-b-2 border-l-2 border-green-400">
        + Application
      </td>
      <td class="px-4 py-2 border-t-2 border-b-2 border-r-2 border-green-400">
        $ {{ maApplicationFee }}
      </td>
    </tr>
    <!-- End Applicacion fee -->
    <tr
      v-if="onlyTN"
      :class="['text-green-900 bg-green-100 font-semibold']"
    >
      <td
        class="border-t-2 border-b-2 border-l-2 border-green-400 px-4 py-2"
        v-if="availableForPayment"
      >
        + Application
      </td>
      <td
        class="border-t-2 border-b-2 border-l-2 border-green-400 px-4 py-2"
        v-else
      >
        Application
      </td>
      <td class="border-t-2 border-b-2 border-r-2 border-green-400 px-4 py-2">
        $ {{ applicationFee }}
      </td>
    </tr>
    <!-- Total payment today -->
    <tr
      v-if="onlyTN || onlyMA"
      :class="['text-green-900 bg-green-100 font-semibold']"
    >
      <td
        class="border-t-2 border-l-2 border-green-400 px-4 py-2"
        :class="[paySelected === 'payFull' ? 'border-b-2' : '']"
      >
        Total Payment Today
      </td>
      <td
        class="border-t-2 border-b-2 border-r-2 border-green-400 px-4 py-2"
        v-if="paySelected === 'payFull'"
      >
        $
        {{
          discountCodeAmount >= totalAmount
            ? 0
            : totalAmount + (applicationFee + maApplicationFee) - discountCodeAmount
        }}
      </td>
      <!-- <td
        class="border-t-2 border-r-2 border-green-400 px-4 py-2"
        v-else-if="paySelected === 'payNotFull' || paySelected === 'payCustom'"
      >
        $ {{ totalAmount + applicationFee }}
      </td>
      <td class="border-t-2 border-r-2 border-green-400 px-4 py-2" v-else>
        $ {{ discountCodeAmount >= totalAmount ? 0 : applicationFee }}
      </td> -->
      <td
        class="border-t-2 border-r-2 border-green-400 px-4 py-2"
        v-else-if="paySelected === 'payNotFull' || paySelected === 'payCustom'"
      >
        $ {{ totalAmount + (applicationFee + maApplicationFee) }}
      </td>
      <td
        class="border-t-2 border-r-2 border-green-400 px-4 py-2"
        v-else
      >
        $ {{ applicationFee || maApplicationFee }}
      </td>
    </tr>
    <!-- End total payment  -->
    <!-- Remaining Balance -->
    <tr
      v-if="!payFull && !payCustom"
      class="bg-red-100 text-red-900 font-semibold"
    >
      <td class="border-t-2 border-b-2 border-l-2 border-red-400 px-4 py-2">
        Remaining Balance
      </td>
      <td
        v-if="forAll || onlyIL"
        class="border-t-2 border-b-2 border-r-2 border-red-400 px-4 py-2"
      >
        $ {{ remainingBalance + after_registration_fees }}
      </td>
      <!-- <td
        v-if="onlyTN"
        class="border-t-2 border-b-2 border-r-2 border-red-400 px-4 py-2"
      >
        $ {{ totalRemainingBalance }}
      </td> -->
      <td
        v-if="onlyTN"
        class="border-t-2 border-b-2 border-r-2 border-red-400 px-4 py-2"
      >
        $ {{ totalRemainingBalance + after_registration_fees }}
      </td>
    </tr>
    <tr
      v-if="payCustom"
      class="bg-red-100 text-red-900 font-semibold"
    >
      <td class="border-t-2 border-b-2 border-l-2 border-red-400 px-4 py-2">
        Remaining Balance
      </td>
      <td
        v-if="forAll || onlyIL"
        class="border-t-2 border-b-2 border-r-2 border-red-400 px-4 py-2"
      >
        $ {{ remainingBalance + after_registration_fees }}
      </td>
      <!-- <td
        v-if="onlyTN"
        class="border-t-2 border-b-2 border-r-2 border-red-400 px-4 py-2"
      >
        $ {{ totalRemainingBalance }}
      </td> -->
      <td
        v-if="onlyTN"
        class="border-t-2 border-b-2 border-r-2 border-red-400 px-4 py-2"
      >
        $ {{ totalRemainingBalance + after_registration_fees }}
      </td>
    </tr>
    <tr
      v-if="payFull && !payCustom"
      class="bg-red-100 text-red-900 font-semibold"
    >
      <td class="border-t-2 border-b-2 border-l-2 border-red-400 px-4 py-2">
        Remaining Balance
      </td>
      <td
        v-if="forAll || onlyIL"
        class="border-t-2 border-b-2 border-r-2 border-red-400 px-4 py-2"
      >
        $ {{ after_registration_fees }}
      </td>
    </tr>
    <!-- End Remaining Balance -->
    <slot
      name="total-coupon-payment"
      :discountCode="discountCode"
      :totalAmount="totalAmount"
      :discountCodeAmount="discountCodeAmount"
      :paySelected="paySelected"
      :onlyTN="onlyTN"
      :onlyMA="onlyMA"
    ></slot>
  </tbody>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  props: [
    "insuranceCost",
    "externshipCost",
    "payFull",
    "payCustom",
    "payCustomAmount",
    "courseCost",
    "name",
    "totalPrice",
    "depositAmount",
    "remainingBalance",
    "hasNationalExam",
    "examFeeCost",
    "discountCode",
    "discountCodeAmount",
    "paySelected",
    "state",
    "withExamFee",
    "availableForPayment",
    "applicationFee",
    "state_fee_items",
  ],
  computed: {
    ...mapState("courseInformation", ["maApplicationFee"]),
    ...mapGetters("courseInformation", [
      "totalAmount",
      "totalBalance",
      "after_registration_fees",
    ]),
    forAll() {
      return this.state !== "IL" && this.state !== "TN";
    },
    onlyIL() {
      return this.state === "IL";
    },
    onlyTN() {
      return this.state === "TN";
    },
    onlyMA() {
      return this.state === "MA";
    },
    totalPayment() {
      return this.totalAmount + this.applicationFee;
    },
    totalRemainingBalance() {
      return (
        this.remainingBalance
        // (this.paySelected === "tnApplicacionFee" ? this.applicationFee : 0)
      ); //+ this.applicationFee;
    },
  },
};
</script>